import {ActionTypes} from './../../cc-imports'
import _ from 'lodash'
import {Constants, DataActionTypes} from "../../cc-imports";

const initialState = {
    byKey : {},

    pages : {},

    reqStatus:'',
    error: '',
    random : 0,
    type : DataActionTypes.GET
};


const processData = (oldState, newSponsors,type, id)=>{
    const byKey = _.keyBy(newSponsors, 'key');
    var exSponsorsByKey = oldState.byId ? oldState.byKey : [];
    exSponsorsByKey = _.merge({}, exSponsorsByKey, byKey);

    var pages = oldState.pages;

    if(id){
        if(pages[id]==undefined){
            pages[id]=0;
        }else {
            if(type==DataActionTypes.PAGINATE){
                pages[id]=pages[id]+1;
            }
        }
    }

    return {
        byKey: exSponsorsByKey,
        pages:pages
    }
};


const SponsorsReducers = (state = initialState, action = {}) => {

    switch (action.type) {
        case (ActionTypes.getCCFulfilled(ActionTypes.GET_SPONSORS)):
            return {
                ...state,
                type : action.meta.type,
                reqStatus: Constants.reqStatus.SUC,
                random:Math.random(),
                error : '',
                ...processData(state,action.payload.data.item, action.meta.type, action.meta.id)
            }
            break;
        case (ActionTypes.getFulfilled(ActionTypes.GET_SPONSORS)):
            return {
                ...state,
                reqStatus: action.meta.type==DataActionTypes.PAGINATE ? Constants.reqStatus.COM : Constants.reqStatus.FAI,
                type: action.meta.type
            }
            break;
        case (ActionTypes.getPending(ActionTypes.GET_SPONSORS)):
            return {
                ...state,
                reqStatus:Constants.reqStatus.PEN,
                type: action.meta.type
            }
            break;
        case (ActionTypes.getRejected(ActionTypes.GET_SPONSORS)):
            return {
                ...state,
                reqStatus:Constants.reqStatus.FAI,
                type: action.meta.type}
            break;
        default :
            return state;
    }
};

export default SponsorsReducers;



// WEBPACK FOOTER //
// ./src/app/data/reducers/SponsorsReducer.js